import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Provider } from 'src/app/models/provider.model';
import { ApiService } from 'src/app/services/api.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { UtilsService } from 'src/app/services/utils.service';
import { AddProviderDialogComponent } from './add-provider-dialog/add-provider-dialog.component';
import { IndexTemplateComponent } from '@bisual/ngx-index-template';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButton,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    MatPaginator,
    MatFormField,
    MatInput,
    MatIconButton,
    MatSuffix,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    RouterLink,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatPrefix,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
  ],
})
export class ProvidersComponent extends IndexTemplateComponent {
  private api = inject(ApiService);
  dialog = inject(MatDialog);
  permissions = inject(PermissionsService);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  displayedColumns: string[] = ['name', 'country', 'actions'];
  dataSource: MatTableDataSource<Provider> = new MatTableDataSource();

  filterForm: UntypedFormGroup;

  constructor() {
    super(inject(Router), inject(UntypedFormBuilder), inject(ActivatedRoute), inject(UtilsService));
  }

  deleteProvider(index: number) {
    const provider = this.dataSource.data[index];
    if (confirm(`¿Estás seguro que quieres eliminar el proveedor "${provider.fact_name}"?`)) {
      this.api.deleteProvider(provider.id).subscribe(data => {
        this.fetchData();
      });
    }
  }

  addProvider() {
    const dialogRef = this.dialog.open(AddProviderDialogComponent, {
      width: '750px',
    });

    dialogRef.afterClosed().subscribe((provider: Provider) => {
      if (provider != null) {
        this.api.createProvider(provider).subscribe(data => {
          this.fetchData();
        });
      }
    });
  }

  override fetchData() {
    this.api.getProvidersPaged(this.filterForm.value).subscribe(data => {
      this.dataSource.data = data.data;

      this.length = +data.meta.total;
      this.pageIndex = +data.meta.current_page - 1;
      this.pageSize = +data.meta.per_page;
    });
  }
}
